<template>
  <div>
    <el-dialog
      id="editDialog"
      :title="orderId ? '修改定制入库单' : '新增定制入库单'"
      :visible="true"
      @close="close(false)"
      width="1000px"
    >
      <el-form
        :model="headInfo"
        label-position="right"
        label-width="115px"
        ref="editOrderFormRef"
        :rules="getRules"
        v-if="headInfo"
      >
        <el-form-item label="单号" v-if="headInfo.id">
          <span v-fmtype="headInfo.orderNo ? null : 'info'">{{
            headInfo.orderNo || "草稿"
          }}</span>
          <el-tag
            class="fm-ml-5"
            :type="
              $jsTool.getOrderApprovalStatusType(
                headInfo.orderApprovalStatusEnum
              )
            "
            >{{ headInfo.orderApprovalStatusEnum.Desc }}</el-tag
          >
        </el-form-item>
        <el-form-item label="单据日期" prop="orderDate">
          <el-date-picker
            v-model="headInfo.orderDate"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择单据日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="供应商" prop="supplierId">
          <SupplierSelect
            :value="supplier"
            @select="selectSupplier"
          ></SupplierSelect>
        </el-form-item>
        <el-form-item label="关联单据" prop="relatedOrderHeadId">
          <el-input
            :value="getSelectLabel('RelatedOrder')"
            :placeholder="
              getSelectLabel('RelatedOrder') || '请选择需要入库的单据'
            "
            style="width: 400px"
            readonly
            suffix-icon="el-icon-arrow-right"
            @click.native="toSelectOrderPage"
          ></el-input>
        </el-form-item>
        <el-form-item label="所选商品" prop="totalInputQuantity">
          <div class="fm-flex">
            <p
              v-fmtype="'success'"
              v-if="totalInputQuantity && totalInputQuantity > 0"
            >
              {{ "共 " + totalInputQuantity + " 件商品" }}
            </p>
            <span v-fmtype="'error'" v-else>未选择商品</span>
            <el-button
              class="fm-ml-15"
              type="primary"
              plain
              size="mini"
              icon="el-icon-plus"
              @click="toSelectOrderItemPage('exist')"
              >选择商品</el-button
            >
          </div>
        </el-form-item>
        <el-table
          :data="itemList || []"
          stripe
          :row-key="
            (row) => {
              return row.itemNo + row.relatedOrderItemId;
            }
          "
          max-height="500px"
          style="width: 100%"
        >
          <el-table-column
            prop="commodityName"
            label="商品信息"
            min-width="180"
            align="left"
            header-align="center"
          >
            <template slot-scope="scope">
              <div style="line-height: 1.3em">
                <el-tooltip class="item" effect="dark" placement="top-start">
                  <div slot="content" style="max-width: 300px">
                    <p>
                      商品名称：{{
                        scope.row.relatedCustomizePurchaseOrderItem
                          .relatedCustomizeOrderItem.commodityName
                      }}
                    </p>
                    <p class="fm-mt-5">
                      备注：
                      <span
                        v-fmtype="
                          scope.row.relatedCustomizePurchaseOrderItem
                            .relatedCustomizeOrderItem.remark
                            ? ''
                            : 'warning'
                        "
                        >{{
                          scope.row.relatedCustomizePurchaseOrderItem
                            .relatedCustomizeOrderItem.remark || "——"
                        }}</span
                      >
                    </p>
                  </div>
                  <div>
                    <p class="fm-line-2">
                      商品名称：{{
                        scope.row.relatedCustomizePurchaseOrderItem
                          .relatedCustomizeOrderItem.commodityName
                      }}
                    </p>
                    <p class="fm-line-2 fm-mt-5">
                      备注：
                      <span
                        v-fmtype="
                          scope.row.relatedCustomizePurchaseOrderItem
                            .relatedCustomizeOrderItem.remark
                            ? ''
                            : 'warning'
                        "
                        >{{
                          scope.row.relatedCustomizePurchaseOrderItem
                            .relatedCustomizeOrderItem.remark || "——"
                        }}</span
                      >
                    </p>
                  </div>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="入库进度"
            width="170"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <div class="fm-flex">
                待入库：{{
                  scope.row.relatedCustomizePurchaseOrderItem.toBeInputQuantity
                }}，入库中：{{
                  scope.row.relatedCustomizePurchaseOrderItem.inputingQuantity
                }}
              </div>
              <div class="fm-flex">
                已入库：{{
                  scope.row.relatedCustomizePurchaseOrderItem
                    .completedInputQuantity
                }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="itemQuantity"
            label="入库数量"
            width="200"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <CommodityQuantityInputBox
                style="width: 120px"
                :key="
                  'itemQuantityInputNumber' + scope.$index + itemQuantityKey
                "
                :value="scope.row.itemQuantity"
                size="mini"
                :max="
                  scope.row.relatedCustomizePurchaseOrderItem.toBeInputQuantity
                "
                @change="
                  (e) => {
                    changeItemQuantity(scope.$index, scope.row, e);
                  }
                "
              ></CommodityQuantityInputBox>
            </template>
          </el-table-column>
        </el-table>

        <el-form-item
          label="纸质单据"
          class="fm-mt-10"
          prop="paperOrderSysFileIdList"
          key="paperOrderSysFileIdList"
        >
          <div
            class="fm-rela fm-uploadDiv-100"
            v-for="(file, index) in paperOrderImageList"
            :key="index"
          >
            <el-image
              :id="'paperImage' + index"
              :src="file.url"
              :preview-src-list="paperOrderImageList.map((d) => d.url)"
              :initial-index="index"
              alt=""
            />
            <div class="LoadingIcon fm-center" v-if="file.status == 'ready'">
              <i class="LoadingIcon-icon el-icon el-icon-loading"></i>
            </div>
            <div class="HandleIcon">
              <i
                @click="paperOrderImagePreview(index)"
                alt="预览图片"
                class="HandleIcon-icon fm-center HandleIcon-previewIcon el-icon el-icon-view"
              ></i>
              <i
                alt="删除图片"
                @click="paperOrderImageDelete(index, file)"
                class="HandleIcon-icon fm-center HandleIcon-deleteIcon el-icon el-icon-delete"
              ></i>
            </div>
          </div>
          <el-upload
            :action="
              $envConfig.VUE_APP_uploadCustomizeInputOrderPaperOrder + ''
            "
            :headers="{
              AuthorityToken: $storageUtil.getAuthorityToken(),
            }"
            :limit="10"
            multiple
            accept="image/*"
            :file-list="paperOrderImageList"
            :show-file-list="false"
            :on-change="paperOrderImageChange"
            :on-success="paperOrderImageSuccess"
            :on-exceed="() => this.$message.warning('最多上传10张图片')"
            v-if="paperOrderImageList.length < 10"
          >
            <div slot="default" class="fm-center fm-uploadDiv-100">
              <i class="el-icon-plus"></i>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            maxlength="50"
            show-word-limit
            v-model="headInfo.remark"
            style="width: 400px"
            placeholder="请输入单据备注信息"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close(false)">取 消</el-button>
        <el-button type="primary" @click="edit(false)"> 保存至草稿 </el-button>
        <el-popconfirm
          icon="el-icon-info"
          :icon-color="$jsTool.getColor('warning')"
          :title="
            orderConfig.needApproval
              ? '是否将单据提交审批？'
              : '当前单据提交后将自动审批通过，请确认单据信息无误，是否继续提交？'
          "
          @confirm="edit(true)"
        >
          <el-button slot="reference" type="success" @click.native.stop>
            保存并提交
          </el-button>
        </el-popconfirm>
      </div>
    </el-dialog>

    <CustomizePurchaseOrderSelectDialog
      :show="customizePurchaseOrderSelectDialogShow"
      :supplierId="supplier.id"
      from="CustomizeInputOrder"
      :selectList="itemList"
      @close="customizePurchaseOrderSelectDialogShow = false"
      @selectCustomizePurchaseOrder="selectCustomizePurchaseOrder"
      v-if="customizePurchaseOrderSelectDialogShow"
    >
    </CustomizePurchaseOrderSelectDialog>

    <CustomizePurchaseOrderItemSelectDialog
      :show="customizePurchaseOrderItemSelectDialogShow"
      from="CustomizeInputOrder"
      :supplierId="supplier.id"
      :customizePurchaseOrderId="relatedCustomizePurchaseOrderHead.id"
      :selectList="itemList"
      @close="customizePurchaseOrderItemSelectDialogShow = false"
      @selectCustomizePurchaseOrderItem="selectCustomizePurchaseOrderItem"
      v-if="customizePurchaseOrderItemSelectDialogShow"
    >
    </CustomizePurchaseOrderItemSelectDialog>
  </div>
</template>

<script>
export default {
  name: "Fmerpv2WebCustomizeInputOrderEditDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    orderId: {
      type: String,
      default: null,
    },
  },
  watch: {
    show: {
      handler(newVal) {
        if (newVal) {
          Object.assign(this.$data, this.$options.data());
          this.$nextTick(() => {
            this.$refs.editOrderFormRef.clearValidate();
          });
          this.initOrderData();
          this.getOrderConfig();
          this.quantityMinLimit = this.$jsTool.getTenantDecimalLength();
          if (this.orderId) {
            setTimeout(async () => {
              await this.getOrderInfo();
              this.$nextTick(() => {
                this.$refs.editOrderFormRef.clearValidate();
              });
            }, 100);
          }
        }
      },
      immediate: true,
    },
  },
  computed: {
    totalInputQuantity() {
      return Number(
        this.$jsTool.sumQuantity(this.itemList.map((d) => d.itemQuantity))
      );
    },
    getRules() {
      let res = {
        orderDate: this.$ruleUtil.simple({
          fieldName: "单据日期",
          handleType: "选择",
          required: true,
        }),
        supplierId: this.$ruleUtil.simple({
          fieldName: "供应商",
          handleType: "选择",
          required: true,
        }),
        relatedOrderHeadId: this.$ruleUtil.simple({
          fieldName: "关联单据",
          handleType: "选择",
          required: true,
        }),
        totalInputQuantity: this.$ruleUtil.quantity(
          "入库商品",
          this.quantityMinLimit
        ),
        paperOrderSysFileIdList: this.$ruleUtil.array(
          "纸质单据",
          "上传",
          this.orderConfig.paperOrderRequired ? 1 : 0,
          10
        ),
        remark: this.$ruleUtil.simple({
          fieldName: "备注",
          required: false,
          max: 200,
        }),
      };
      return res;
    },
  },
  data() {
    return {
      orderConfig: {
        needApproval: true,
        paperOrderRequired: true,
      },

      // 预选的单据信息
      preInfo: {
        customizePurchaseOrderId: null,
        customizePurchaseOrder: {},
      },

      orderDatePickerShow: false,

      editItemPopupShow: false,
      editItem: {},

      id: null,
      headInfo: {
        orderApprovalStatusEnum: {},
        orderDate: null,
        supplierId: null,
        relatedOrderHeadId: null,
        totalInputQuantity: 0,
        needDelivery: true,
        paperOrderSysFileIdList: [],
        remark: "",
        orderParam: "",
      },
      itemList: [],
      supplier: {},
      relatedCustomizePurchaseOrderHead: {},
      paperOrderImageList: [],

      customizePurchaseOrderSelectDialogShow: false,
      customizePurchaseOrderItemSelectDialogShow: false,

      itemQuantityKey: "null",

      quantityMinLimit: 0.001,
    };
  },

  mounted() {},

  methods: {
    close(flush) {
      this.$emit("close", flush);
    },

    // 纸质单据有关
    paperOrderImagePreview(index) {
      document.getElementById("paperImage" + index).click();
    },
    paperOrderImageDelete(index, file) {
      this.paperOrderImageList.splice(index, 1);
      this.initPaperOrderSysFileIdList();
    },
    paperOrderImageChange(file, fileList) {
      if (file.status == "ready") {
        this.paperOrderImageList.push({
          ...file,
          url: file.url || URL.createObjectURL(file.raw),
          status: "ready",
        });
      }
      this.initPaperOrderSysFileIdList();
    },
    paperOrderImageSuccess(res, file, fileList) {
      let index = this.paperOrderImageList.findIndex((d) => d.uid == file.uid);
      if (res && res.success) {
        this.$message({
          message: "文件上传成功",
          type: "success",
        });
        this.paperOrderImageList.splice(index, 1, {
          ...this.paperOrderImageList[index],
          url: res.data.prefix + res.data.name,
          id: res.data.id,
          status: "success",
        });
      } else {
        this.$message({
          message: res.message || "文件上传失败",
          type: "error",
        });
        this.paperOrderImageList.splice(index, 1);
      }
      this.initPaperOrderSysFileIdList();
    },
    initPaperOrderSysFileIdList() {
      this.$nextTick(() => {
        this.headInfo.paperOrderSysFileIdList = this.paperOrderImageList
          .filter((d) => d.status == "success")
          .map((d) => d.id);
        this.$refs.editOrderFormRef.validateField("paperOrderSysFileIdList");
      });
    },

    initOrderData() {
      this.headInfo.orderDate = this.$moment(new Date()).format("yyyy-MM-DD");
    },
    async getOrderConfig() {
      let res = await this.$api.tenantPersonalConfig_findByCodeIn([
        "Order:CustomizeInputOrder:NeedApproval",
        "Order:CustomizeInputOrder:PaperOrderRequired",
      ]);
      if (res && res.success) {
        let needApprovalIndex = res.data.findIndex(
          (d) => d.code == "Order:CustomizeInputOrder:NeedApproval"
        );
        if (
          needApprovalIndex > -1 &&
          res.data[needApprovalIndex].value == "false"
        ) {
          this.orderConfig.needApproval = false;
        }
        let paperOrderRequiredIndex = res.data.findIndex(
          (d) => d.code == "Order:CustomizeInputOrder:PaperOrderRequired"
        );
        if (
          paperOrderRequiredIndex > -1 &&
          res.data[paperOrderRequiredIndex].value == "false"
        ) {
          this.orderConfig.paperOrderRequired = false;
        }
      }
    },

    // 获取已选择的文本
    getSelectLabel(type) {
      if (type == "Supplier") {
        if (this.supplier && this.supplier.name) {
          return this.supplier.name;
        }
      } else if (type == "RelatedOrder") {
        if (
          this.relatedCustomizePurchaseOrderHead &&
          this.relatedCustomizePurchaseOrderHead.id
        ) {
          return this.relatedCustomizePurchaseOrderHead.orderNo;
        }
      }
      return null;
    },

    selectSupplier(item) {
      this.headInfo.supplierId = item.id;
      this.supplier = item;
      // 清空已选销售单和商品
      this.headInfo.relatedOrderHeadId = null;
      this.relatedCustomizePurchaseOrderHead = {};
      this.itemList = [];
      this.selectCustomizePurchaseOrderItem(this.itemList || []);
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.validateField("supplierId");
      });
      setTimeout(() => {
        this.toSelectOrderPage();
      }, 200);
    },
    // 选择销售单
    toSelectOrderPage() {
      if (
        this.preInfo.customizePurchaseOrderId ||
        this.preInfo.customizePurchaseOrderId
      ) {
        this.$message.error("自动创建入库单时无法重新选择入库单据");
        return;
      }
      if (!this.supplier || !this.supplier.id) {
        this.$message.error("请先选择供应商");
        return;
      }
      this.customizePurchaseOrderSelectDialogShow = true;
    },
    selectCustomizePurchaseOrder(order) {
      this.headInfo.relatedOrderHeadId = order.id;
      this.relatedCustomizePurchaseOrderHead = order;
      this.itemList = [];
      this.selectCustomizePurchaseOrderItem(this.itemList || []);
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.validateField("relatedOrderHeadId");
      });
      setTimeout(() => {
        this.toSelectOrderItemPage();
      }, 200);
    },
    // 选择单据行项目
    async toSelectOrderItemPage(exist) {
      if (!this.supplier || !this.supplier.id) {
        this.$message.error("请先选择供应商");
        return;
      }
      if (
        !this.relatedCustomizePurchaseOrderHead ||
        !this.relatedCustomizePurchaseOrderHead.id
      ) {
        this.$message.error("请先选择定制单");
        return;
      }
      this.customizePurchaseOrderSelectDialogShow = false;
      if (!exist) {
        let getOrderRes = await this.$api.customizePurchaseOrder_findVoById(
          this.headInfo.relatedOrderHeadId,
          {
            showLoading: true,
            loadingParam: {
              target: "#editDialog > *",
              lock: true,
              text: "加载中...",
            },
          }
        );
        if (getOrderRes && getOrderRes.success) {
          let purchaseOrderVo = getOrderRes.data;
          this.handleConstructItemInfo(purchaseOrderVo.itemList);
          return;
        }
      }
      this.customizePurchaseOrderItemSelectDialogShow = true;
    },
    handleConstructItemInfo(itemList) {
      let res = [];
      for (let index in itemList) {
        let item = itemList[index];
        if (item.toBeInputQuantity <= 0) {
          continue;
        }
        let constructItem = {
          itemNo: index + 1,
          relatedOrderItemId: item.id,
          relatedCustomizePurchaseOrderItem: item,
          itemQuantity: item.toBeInputQuantity,
        };
        res.push(constructItem);
      }
      this.selectCustomizePurchaseOrderItem(res);
    },
    selectCustomizePurchaseOrderItem(itemList) {
      this.itemList = itemList;
      this.headInfo.totalInputQuantity = Number(
        this.$jsTool.sumQuantity(itemList.map((d) => d.itemQuantity))
      );
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.validateField("totalInputQuantity");
      });
    },
    changeItemQuantity(index, row, value) {
      let that = this;
      if (value < 0) {
        row.itemQuantity = 0;
      }
      if (value <= 0) {
        that
          .$confirm("是否移除所选商品?", "操作提醒", {
            confirmButtonText: "移除",
            cancelButtonText: "取消",
            type: "warning",
            closeOnClickModal: false,
            closeOnPressEscape: false,
            closeOnHashChange: false,
          })
          .then(() => {
            that.itemList.splice(index, 1);
            that.itemQuantityKey = Math.random();
            that.selectCustomizePurchaseOrderItem(that.itemList || []);
          })
          .catch(() => {
            row.itemQuantity = 1;
            that.itemQuantityKey = Math.random();
          });
      } else {
        row = {
          ...row,
          itemQuantity: value,
        };
        that.itemList.splice(index, 1, row);
        that.selectCustomizePurchaseOrderItem(that.itemList || []);
      }
    },

    async getOrderInfo(args) {
      let res = await this.$api.customizeInputOrder_findVoById(
        this.orderId,
        args
      );
      if (res && res.success) {
        this.headInfo = {
          ...res.data.head,
          remark: res.data.head.remark || "",
          paperOrderSysFileIdList: res.data.head.paperOrderImageList.map(
            (d) => d.sysFile.id
          ),
        };
        this.itemList = res.data.itemList;
        this.supplier = res.data.head.supplier;
        this.relatedCustomizePurchaseOrderHead =
          res.data.head.relatedCustomizePurchaseOrderHead;
        this.paperOrderImageList = res.data.head.paperOrderImageList.map(
          (item) => {
            return {
              imageName: item.sysFile.name,
              id: item.sysFile.id,
              message: "已有图片",
              status: "success",
              thumb: item.sysFile.prefix + item.sysFile.name,
              type: "image",
              url: item.sysFile.prefix + item.sysFile.name,
            };
          }
        );
        if (this.headInfo.orderParam) {
          let orderParam = JSON.parse(this.headInfo.orderParam);
          this.preInfo.customizePurchaseOrderId =
            orderParam.preInfo.customizePurchaseOrderId;
        }
      }
    },

    edit(submit) {
      this.$refs.editOrderFormRef.validate(async (valid) => {
        if (!valid) {
          return;
        }
        let requestRes = this.headInfo.id
          ? submit
            ? await this.$api.customizeInputOrder_updateAndSubmit(
                {
                  headUpdatePojo: this.headInfo,
                  itemAddNewPojoList: this.itemList,
                },
                {
                  showLoading: true,
                  loadingParam: {
                    target: "#editDialog > *",
                    lock: true,
                    text: "修改中...",
                  },
                }
              )
            : await this.$api.customizeInputOrder_update(
                {
                  headUpdatePojo: this.headInfo,
                  itemAddNewPojoList: this.itemList,
                },
                {
                  showLoading: true,
                  loadingParam: {
                    target: "#editDialog > *",
                    lock: true,
                    text: "修改中...",
                  },
                }
              )
          : submit
          ? await this.$api.customizeInputOrder_saveIntoDraftAndSubmit(
              {
                headAddNewPojo: this.headInfo,
                itemAddNewPojoList: this.itemList,
              },
              {
                showLoading: true,
                loadingParam: {
                  target: "#editDialog > *",
                  lock: true,
                  text: "新增中...",
                },
              }
            )
          : await this.$api.customizeInputOrder_saveIntoDraft(
              {
                headAddNewPojo: this.headInfo,
                itemAddNewPojoList: this.itemList,
              },
              {
                showLoading: true,
                loadingParam: {
                  target: "#editDialog > *",
                  lock: true,
                  text: "新增中...",
                },
              }
            );
        if (requestRes && requestRes.success) {
          this.close(true);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/order/CustomizeInputOrderEditDialog.vue